// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Aura Operations API
 * API to manage aura-operations
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HandlerOperationResponse } from './HandlerOperationResponse';
import {
  HandlerOperationResponseFromJSON,
  HandlerOperationResponseFromJSONTyped,
  HandlerOperationResponseToJSON,
  HandlerOperationResponseToJSONTyped,
} from './HandlerOperationResponse';

/**
 *
 * @export
 * @interface HandlerOperationListResponse
 */
export interface HandlerOperationListResponse {
  /**
   *
   * @type {Array<HandlerOperationResponse>}
   * @memberof HandlerOperationListResponse
   */
  operations?: Array<HandlerOperationResponse>;
}

/**
 * Check if a given object implements the HandlerOperationListResponse interface.
 */
export function instanceOfHandlerOperationListResponse(
  value: object,
): value is HandlerOperationListResponse {
  return true;
}

export function HandlerOperationListResponseFromJSON(
  json: any,
): HandlerOperationListResponse {
  return HandlerOperationListResponseFromJSONTyped(json, false);
}

export function HandlerOperationListResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): HandlerOperationListResponse {
  if (json == null) {
    return json;
  }
  return {
    operations:
      json['operations'] == null
        ? undefined
        : (json['operations'] as Array<any>).map(
            HandlerOperationResponseFromJSON,
          ),
  };
}

export function HandlerOperationListResponseToJSON(
  json: any,
): HandlerOperationListResponse {
  return HandlerOperationListResponseToJSONTyped(json, false);
}

export function HandlerOperationListResponseToJSONTyped(
  value?: HandlerOperationListResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    operations:
      value['operations'] == null
        ? undefined
        : (value['operations'] as Array<any>).map(
            HandlerOperationResponseToJSON,
          ),
  };
}
